import { createActions } from 'redux-actions';
import { upload, request } from '../../services';

const {
  payRateUploadsFileUpload,
  payRateUploadsFileUploadFailure,
  payRateUploadsFileUploadSuccess,
} = createActions({
 /*
  *  We need to add the installer id, because the API does not includes it in the response
  *  Notice that the client side schema should NOT have an installer relation declared
  * to make this work properly.
  */
  PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS: (json, id) => ({
    installer: id,
    ...json.labor_rate_upload,    // Update this when the API changes the endpoint name
  }),
}, 'PAY_RATE_UPLOADS_FILE_UPLOAD', 'PAY_RATE_UPLOADS_FILE_UPLOAD_FAILURE');

export function uploadInstallerPayRate(id, formData, crewId = '') {
  return (dispatch) => {
    dispatch(payRateUploadsFileUpload());
    return upload(formData, `installers/${id}/labor_rate_uploads?crew_id=${crewId}`)
      .then(({ json }) => {
        dispatch(payRateUploadsFileUploadSuccess(json, id));
      },
      (error) => {
        dispatch(payRateUploadsFileUploadFailure(error));
      });
  };
}


const {
  payRateUploadsListRequest,
  payRateUploadsListRequestSuccess,
  payRateUploadsListRequestFailure,
} = createActions({
  PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS: (json, id) => {
    const payRateUploads = {
      pay_rate_uploads: json.labor_rate_uploads.map(up => ({
        installer: id,
        ...up,
      })),
    };
    return payRateUploads.pay_rate_uploads;
  },
}, 'PAY_RATE_UPLOADS_LIST_REQUEST', 'PAY_RATE_UPLOADS_LIST_REQUEST_FAILURE');

export function requestInstallerPayRateUploads(id) {
  return (dispatch) => {
    dispatch(payRateUploadsListRequest());
    return request(`installers/${id}/labor_rate_uploads`)
      .then(({ json }) => {
        dispatch(payRateUploadsListRequestSuccess(json, id));
      },
      (error) => {
        dispatch(payRateUploadsListRequestFailure(error));
      },
    );
  };
}

export function toggleInstallerPayRateUploadDialog() {
  return { type: 'PAY_RATE_UPLOADS_TOGGLE_DIALOG' };
}

export function setPayRateUploadErrorMessage(errors) {
  return (dispatch) => {
    dispatch({ type: 'PAY_RATE_UPLOADS_FILE_UPLOAD_FAILURE', payload: { errors } });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/pay_rates_uploads.js